var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essentials"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.26797 15.1874H4.125C3.97582 15.1874 3.83275 15.1282 3.72726 15.0227C3.62177 14.9172 3.5625 14.7741 3.5625 14.6249V11.482C3.56225 11.4089 3.5764 11.3366 3.60415 11.269C3.6319 11.2014 3.6727 11.14 3.72422 11.0882L12.1617 2.65072C12.2141 2.59757 12.2765 2.55537 12.3453 2.52656C12.4141 2.49775 12.4879 2.48291 12.5625 2.48291C12.6371 2.48291 12.7109 2.49775 12.7798 2.52656C12.8486 2.55537 12.9109 2.59757 12.9633 2.65072L16.0992 5.78666C16.1524 5.839 16.1946 5.90139 16.2234 5.97019C16.2522 6.039 16.267 6.11284 16.267 6.18744C16.267 6.26203 16.2522 6.33588 16.2234 6.40469C16.1946 6.47349 16.1524 6.53588 16.0992 6.58822L7.66172 15.0257C7.60995 15.0772 7.54852 15.118 7.48095 15.1458C7.41339 15.1735 7.34101 15.1877 7.26797 15.1874V15.1874Z",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M10.3125 4.5L14.25 8.4375",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0da81b52fe72f685e8017b3f43283462.svg";
export { ForwardRef as ReactComponent };